export default __webpack_public_path__ + "static/OnTheGo-a834cfa2e50d1c561e892f98a990dcbf.jpg";